/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMyProfileRequest
 */
export interface UpdateMyProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileRequest
     */
    countryState?: string;
    /**
     * ISO 3166-1 alpha-2 country code.
     * @type {string}
     * @memberof UpdateMyProfileRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileRequest
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileRequest
     */
    officeName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileRequest
     */
    website?: string | null;
}

/**
 * Check if a given object implements the UpdateMyProfileRequest interface.
 */
export function instanceOfUpdateMyProfileRequest(value: object): value is UpdateMyProfileRequest {
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('officeName' in value) || value['officeName'] === undefined) return false;
    return true;
}

export function UpdateMyProfileRequestFromJSON(json: any): UpdateMyProfileRequest {
    return UpdateMyProfileRequestFromJSONTyped(json, false);
}

export function UpdateMyProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMyProfileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'countryState': json['countryState'] == null ? undefined : json['countryState'],
        'country': json['country'] == null ? undefined : json['country'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'phoneNumber': json['phoneNumber'],
        'officeName': json['officeName'],
        'website': json['website'] == null ? undefined : json['website'],
    };
}

export function UpdateMyProfileRequestToJSON(json: any): UpdateMyProfileRequest {
    return UpdateMyProfileRequestToJSONTyped(json, false);
}

export function UpdateMyProfileRequestToJSONTyped(value?: UpdateMyProfileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'countryState': value['countryState'],
        'country': value['country'],
        'timezone': value['timezone'],
        'phoneNumber': value['phoneNumber'],
        'officeName': value['officeName'],
        'website': value['website'],
    };
}

